module.exports = __webpack_public_path__ + "static/media/Ad_Leads.65b35377.svg";